import { Badge } from "@mantine/core";
import type { CollectedFeeStatus } from "../../apis/tenantCollectedFee";

const COLOR: Record<CollectedFeeStatus, string> = {
  PENDING : "yellow",
  DEDUCTED: "blue",
  INVOICED: "indigo",
  SETTLED : "teal",
  WAIVED  : "gray",
  FAILED  : "red",
  REFUNDED: "orange"
};

const LABEL: Record<CollectedFeeStatus, string> = {
  PENDING : "Хүлээгдэж буй",
  DEDUCTED: "Хассан",
  INVOICED: "Нэхэмжилсэн",
  SETTLED : "Төлсөн",
  WAIVED  : "Хүчингүйд",
  FAILED  : "Алдсан",
  REFUNDED: "Буцаасан"
};

export function CollectedFeeStatusBadge({ status }: { status: CollectedFeeStatus }) {
  return <Badge color={COLOR[status]} variant="light">{LABEL[status]}</Badge>;
}
